module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/is-iterable.js
 ** module id = ./node_modules/babel-runtime/core-js/is-iterable.js
 ** module chunks = 0
 **/